<template>
    <div class="form_mobil">
        <div class="card">
            <div class="card-block">
                <h5>Zobrazenie sumárnych čísiel</h5>
                <p>Sumárne čísla sa zobrazia na vrchu cenovej ponuky a obsahujú názov a výslednú cenu každého celku. Je možné pridať maximálne 4 čísla.</p>
                <div class="form-group d-flex mb-4" style="align-items: flex-end;">
                    <input 
                        v-model="isRows"
                        @change="changeIsRows"
                        type="checkbox" class="toggle" />
                    <label class="block sumernecisla" @click="isRows = !isRows" style="cursor:pointer;">
                        <div class="info w-100 ml-3">
                            <div class="my_tooltip">
                                <img src="/img/rows.png" alt="">
                            </div>
                            <div class="tooltip_hover info_icon">
                                <img src="/img/info_icon.svg" alt="">
                            </div>
                        </div>
                        Zobraziť sumárne čísla
                    </label>
                </div>
                <div v-show="isRows">
                    <div class="inputs">
                        <draggable v-model="rows" handle=".hold">
                            <transition-group>
                                <div v-for="item in rows" :key="item.id" class="one">
                                    <svg class="hold" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                        <line x1="0.5" y1="0.5" x2="7.5" y2="0.5" stroke="#9598A7" stroke-linecap="round"/>
                                        <line x1="0.5" y1="4.5" x2="7.5" y2="4.5" stroke="#9598A7" stroke-linecap="round"/>
                                        <line x1="0.5" y1="8.5" x2="7.5" y2="8.5" stroke="#9598A7" stroke-linecap="round"/>
                                    </svg>
                                    <div class="middle">
                                        <div class="form-floating nazov">
                                            <input 
                                                v-model="item.nazov" 
                                                @input="filterEntries(item)" 
                                                @focus="showAllEntries(item)"
                                                @blur="$set(item, 'showDropdown', false)"
                                                type="text" 
                                                class="form-control" 
                                                id="floatingInput" 
                                                placeholder="Názov"
                                                autocomplete="off"    
                                            >
                                            <label for="floatingInput">Názov</label>
                                            <div class="dropdown" v-if="item.showDropdown">
                                                <ul>
                                                    <li 
                                                        v-for="entry in item.filteredEntries" 
                                                        :key="entry.id" 
                                                        @mousedown.prevent="selectEntry(item, entry)">
                                                        {{ entry.name }} - 
                                                        <span v-if="entry.price === entry.price_to">
                                                            {{ entry.price }}
                                                        </span> 
                                                        <span v-else>
                                                            {{ entry.price }} - {{ entry.price_to }}
                                                        </span> 
                                                        {{ suffix_price.suffix }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="form-floating suma relative-container">
                                            <span v-if="item.suma" class="input-suffix">{{ suffix_price.suffix }}</span>
                                            <input 
                                                v-model="item.suma"   
                                                type="text" 
                                                class="form-control cena-input" 
                                                id="floatingInput" 
                                                placeholder="Suma"
                                                >
                                            <label for="floatingSuma">Cena</label>
                                        </div> 
                                    </div>
                                    <svg @click="removeRow(item)" class="trash" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M2 4H3.33333H14" stroke="#9598A7" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M5.3335 3.99992V2.66659C5.3335 2.31296 5.47397 1.97382 5.72402 1.72378C5.97407 1.47373 6.31321 1.33325 6.66683 1.33325H9.3335C9.68712 1.33325 10.0263 1.47373 10.2763 1.72378C10.5264 1.97382 10.6668 2.31296 10.6668 2.66659V3.99992M12.6668 3.99992V13.3333C12.6668 13.6869 12.5264 14.026 12.2763 14.2761C12.0263 14.5261 11.6871 14.6666 11.3335 14.6666H4.66683C4.31321 14.6666 3.97407 14.5261 3.72402 14.2761C3.47397 14.026 3.3335 13.6869 3.3335 13.3333V3.99992H12.6668Z" stroke="#9598A7" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M6.6665 7.33325V11.3333" stroke="#9598A7" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9.3335 7.33325V11.3333" stroke="#9598A7" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </transition-group>
                        </draggable>
                    </div>
                    <div class="bottom">
                        <div class="check">
                            <label class="check_container">
                                <input 
                                    v-model="total"
                                    type="checkbox">
                                <span class="check_checkmark"></span>
                            </label>
                            <span class="check_txt" @click="total = !total" style="cursor:pointer;">
                                Pridať automatický súčet nakoniec
                            </span>
                            <div class="info">
                                <div class="my_tooltip"> 
                                    Ak zaklikneš túto možnosť, na koniec riadku pridáme celkovú cenu tvojej ponuky.
                                </div>
                                <div class="tooltip_hover info_icon">
                                    <img src="/img/info_icon.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="btn_text">
                            <div :class="count < 3 ? 'add': 'add diasbled'" @click="addRow">
                                + Pridať ďalšie číslo
                            </div>
                            <p>{{count}} zo 3 možných</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable/src/vuedraggable'
import {Money} from 'v-money'
export default {
    components: {draggable, Money},
    props: [ 'styleRows', 'celkovaCena', 'entries' ],
    data() {
        return {          
            suffix_price: {
                thousands: ' ',
                suffix: ' €',
                precision: 0
            },
            isRows: false,
            total: false,
            count: 1,
            rows: [
                { id: 1, nazov: null, suma: null, filteredEntries: [], showDropdown: false }
            ],
            startEntries: null
        }
    },
    methods: {
        filterEntries(item) {
            const query = item.nazov ? item.nazov.toLowerCase() : '';
            const filtered = query 
                ? this.entries.filter(entry => entry.name && entry.name.toLowerCase().includes(query))
                : this.entries;

            this.$set(item, 'filteredEntries', filtered);
            this.$set(item, 'showDropdown', query.length > 0 && filtered.length > 0);
        },
        showAllEntries(item) {
            this.$set(item, 'filteredEntries', this.entries);
            this.$set(item, 'showDropdown', true);
        },
        selectEntry(item, entry) {
            item.nazov = entry.name;
            if (entry.price === entry.price_to) {
                item.suma = entry.price
            } else {
                item.suma =  entry.price + " - " + entry.price_to
            }
            item.showDropdown = false;
        },
        removeRow(row){
            this.count--
            var index = this.rows.indexOf(row);
            if (index !== -1) {
                this.rows.splice(index, 1);
            }
        },
        addRow() {
            if(this.isRows){
                this.count++
                var row = {
                    id: this.rows.length + 1,
                    nazov: null,
                    suma: null,
                }
                this.rows.push(row)
            }
        },
        changeIsRows(){
            if(this.isRows){
                // this.count++
                // var row = {
                //     id: 1,
                //     nazov: null,
                //     suma: null,
                // }
                // this.rows.push(row)
            }else{
                this.count = 0
                this.rows = []
             
            }
        }
    },
    watch: {
        'rows': function(){
            var i = 1;
            this.rows.forEach(item => {
                item.id = i
                i++
            });
            var data = {
                isRows: this.isRows,
                rows: this.rows,
                isCelkova: this.total,
                celkova: this.celkovaCena
            }
            this.$emit('getData',data)
        },
        'celkovaCena': function() {
            var data = {
                isRows: this.isRows,
                rows: this.rows,
                isCelkova: this.total,
                celkova: this.celkovaCena
            }
            this.$emit('getData',data)
        },
        'total': function(){
            var data = {
                isRows: this.isRows,
                rows: this.rows,
                isCelkova: this.total,
                celkova: this.celkovaCena
            }
            this.$emit('getData',data)
        },
        'styleRows.isRows': function() {
            if(this.styleRows.isRows == 1){
                this.isRows = true
                this.count = 0
                this.rows = []
                this.styleRows.price_rows.forEach(row => {
                    if(row.celkova == 1){
                        this.total = true
                    }else{
                        this.count++
                        var row = {
                            id: this.rows.length + 1,
                            nazov: row.nazov,
                            suma: row.cena,
                        }
                        this.rows.push(row)
                    }
                });
            }
        }
    },
    mounted () {
        $( ".tooltip_hover" ).hover(
            function() {
                $( this ).parent().find('.my_tooltip').css('opacity', '1');
            },
            function() {
                $( this ).parent().find('.my_tooltip').css('opacity', '0');
            },  
        );

        this.rows.forEach(item => {
            item.showDropdown = false;
            item.filteredEntries = [];
        });

        document.addEventListener('click', this.closeAllDropdowns);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeAllDropdowns);
    },
}
</script>

<style lang="scss" scoped>  
    .inputs{
        .one{
            width: 100%;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            @media (max-width: 600px) {
                gap: 5px;
            }
            svg.hold{
                cursor: all-scroll;
            }
            svg.trash{
                cursor: pointer;
            }
            .middle{
                display: flex;
                width: 95%;
                margin: 0 auto;
                input{
                    font-family: Roboto;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 16px;

                    color: #212541;
                    border-radius: 0;
                }
                label{
                    font-family: Roboto;
                    font-style: normal;
                    font-weight: bold;
                    font-size: 11px;
                    line-height: 13px;
                    letter-spacing: 0.1em;
                    text-transform: uppercase;
                    color: #9598A7;
                    padding: 20px 11px;
                }
                .nazov{
                    width: 80%;
                    @media (max-width: 600px) {
                        width: 70%;
                    }
                }
                .suma{
                    width: 20%;
                    @media (max-width: 600px) {
                        width: 30%;
                    }
                    input{
                        border-left: none;
                        text-align: right;
                    }
                    label{
                        left: unset;
                        right: 0;
                        padding: 20px 7px;
                    }
                }
            }
        }
    }
    .bottom{
        width: 100%;
        .check{
            width: 270px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 16px;
            margin: 21px 0;
            @media (max-width: 600px) {
                gap: 10px;
            }
            span.check_txt{
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 16px;
                color: #212541;
            }
            .check_container {
                position: relative;
                cursor: pointer;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;    
                width: 16px;
                height: 16px;
            }
            .check_container input {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                height: 0;
                width: 0;
            }
            .check_checkmark {
                position: absolute;
                top: 0;
                left: 0;
                height: 16px;
                width: 16px;
                background-color:  #FFFFFF;
                border: 1px solid #212541;
                border-radius: 3px;
            }
            .check_container:hover input ~ .check_checkmark {
                background-color: #FFFFFF;
            }
            .check_container input:checked ~ .check_checkmark {
                background-color:  #212541;
            }
            .check_checkmark:after {
                content: "";
                position: absolute;
                display: none;
            }
            .check_container input:checked ~ .check_checkmark:after {
                display: block;
            }
            .check_container .check_checkmark:after {
                left: 5px;
                top: 1px;
                width: 5px;
                height: 10px;
                border: 1px solid #fff;
                border-width: 0 2px 2px 0;
                transform: rotate(45deg);
            }
        }
        .btn_text{
            width: 100%;
            margin: 0 auto;
            display: flex;
            align-items: center;
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            p{
                font-size: 13px;
                line-height: 15px;
                color: #9598A7;
                margin-bottom: 0;
            }
            .add{
                width: 160px;
                height: 40px;
                background: #F2F7FB;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 13px;
                line-height: 15px;
                text-align: center;

                color: #212541;
                cursor: pointer;
                &:hover{
                    background: #deebf6;
                }
                margin-right: 15px;
            }
            .add.diasbled{
                pointer-events: none;
                cursor: no-drop;
                opacity: 0.8;
            }
        }
    }
    .form_mobil{
        width: 100%;
        @media (max-width: 500px) {
            padding: 0;
        }

        .card{
            border: none;
            background: #FFFFFF;
            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
            border-radius: 4px;
            @media (max-width: 500px) {
                margin-bottom: 10px;
            }
            .card-block{
                @media (max-width: 500px) {
                    padding: 10px;
                }
            }
        }
    }
    .card-block{
        @media (max-width: 400px) {
            padding: 1.25rem 10px;
        }
        h5{
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 18px;
            line-height: 21px;
            color: #212541;
        }
        p{         
            margin: 7px 0 20px 0;               
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #9598A7;

        }
    }
    .error{
        border: 1px solid red !important;
        border-radius: .25rem;
    }
    .form-floating.active input{
        background-color: #BEC8DE;
    }
    label{
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        color: #212541;
    }
    .save{
        width: 300px;
        height: 58px;
        background: #2ED8B6;
        border: none;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        font-family: Quicksand;
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 182.5%;
        color: #FFFFFF;
        cursor: pointer;
        &:hover{
            background: #24c2a2;
        }
        &:focus{
            outline: none;
        }
    }
    .trash path {
      stroke:#C3C8CF;
    }
    .trash:hover > path{
      stroke:#383C4C;
    }
    .sumar{
        margin-top: 13px;
        justify-content: space-between;
        @media (max-width: 500px) {
            position: relative;
            display: block !important;
        }
        .NazovInput{
            @media (max-width: 800px) {
                margin-right: 10px;
            }
            @media (max-width: 500px) {
                width: 100%;
                margin-bottom: 10px;
                margin-right: 0px;
            }
        }
    }
    .sumar span{
        width: 6%;
        text-align: center;
        font-family: Quicksand;
        font-size: 17px;
        font-style: normal;
        font-weight: 500;
        line-height: 21px;
        color: #263544;
        @media (max-width: 500px) {
            display: flex;
            justify-content: center;
            width: 100%;
            margin-bottom: 10px;
        }
    }
    .sumar .tt{
        width: 3%;
        margin-left: 10px;
        cursor: pointer;
        @media (max-width: 500px) {
            position: absolute;
            top: 0;
            right: 10px;
        }
    }
    .info{
        position: relative;
        height: 20px;
        .info_icon{
            pointer-events: all;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            float: right;
            img{
                width: 80%;
                height: 80%;
            }
            @media (max-width: 400px) {
                float: none;
                margin-left:auto;
                margin-right: 35px;
            }
        }
        .my_tooltip{
            bottom: 21px;
            right: -7px;
            max-width: 250px;
        }
    }
    .agree_tooltip{
        position: relative;
    }
    .my_tooltip{
        pointer-events: none;
        opacity: 0;
        text-align: center;
        z-index: 2000 !important;
        display: grid;
        align-items: center;
        justify-content: center;
        width: max-content;
        background: #F3385A;
        box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
        border-radius: 6px;
        font-weight: 800;
        font-size: 15px;
        line-height: 18px;
        color: #fff;
        padding: 10px;
        position: absolute;
        top: unset;
        right: 15px;
        z-index: 10;
        transition: opacity .5s ease-in-out;
        img{
            margin-top: 5px;
            width: 340px;
            height: 215px;
        }
        &::after{
            content: '';
            width: 11px;
            height: 11px;
            background: #F3385A;
            position: absolute;
            right: 12px;
            bottom: -3px;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            border-radius: 3px;
        }
    }
    .form-group{
        margin-bottom: 10px;
    }
    .row{
        align-items: flex-end;
    }
    .row.change{
        align-items: baseline;
    }
    label{
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;

        color: #212541;
        margin-bottom: 0;
        @media (max-width: 400px) {
            font-size: 13px;
        }
    }
    input[type="checkbox"] {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-tap-highlight-color: transparent;
        cursor: pointer;
        margin: 0px 10px 0 0;
        background: #C7D4EB;
        border-radius: 25px;
    }
    input[type="checkbox"]:focus {
        outline: 0;
    }
    .toggle label {
        @media (max-width: 600px) {
            width: 70%;
        }
    }
    .toggle {
        height: 22px;
        width: 40px;
        display: inline-block;
        position: relative;
        margin: 0;
        border: none;
        background: #FFFFFF;
        border-radius: 3px;
        transition: all 0.2s ease;
    }
    .toggle:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 3px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: white;
        box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
        transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
    }
    .toggle:checked {
        border-color: #2ED8B6;
        background: #2ED8B6;
    }
    .toggle:checked:after {
        transform: translatex(20px);
        @media (max-width: 350px) {
            transform: translatex(12px);
        }
        @media (max-width: 500px) and (min-width:351px) {
            transform: translatex(16px);
        }
        
    }
    .final .polozka_sum{

        width: auto;
        height: auto;

        font-family: Quicksand;
        font-style: normal;
        font-weight: 800;
        font-size: 16px;
        line-height: 16px;
        color: rgb(243, 56, 90);

        display: flex;
        justify-content: center;
        align-items: center;

        background: transparent;
        border-radius: 4px;
        border: 1px solid rgb(243, 56, 90);

        padding: 2px 4px;
        span{
            text-decoration: line-through;
            font-size: 11px;
        }
    }
    .sumernecisla{

        .info{
            position: relative;
            width: 90%;
            height: 20px;
            .info_icon{
                pointer-events: all;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                float: right;
                img{
                    width: 80%;
                    height: 80%;
                }
                @media (max-width: 400px) {
                    float: none;
                    margin-left:auto;
                    margin-right: 35px;
                }
            


            }
            .my_tooltip{
                bottom: 21px;
                right: -7px;
            }
            .agree_tooltip{
                position: relative;
            }
            .my_tooltip{
                pointer-events: none;
                opacity: 0;
                text-align: center;
                z-index: 2000 !important;
                display: grid;
                align-items: center;
                justify-content: center;
                width: max-content;
                background: #F3385A;
                box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
                border-radius: 6px;
                font-weight: 800;
                font-size: 15px;
                line-height: 18px;
                color: #fff;
                padding: 10px;
                position: absolute;
                top: unset;
                right: -7px;
                z-index: 10;
                transition: opacity .5s ease-in-out;
                img{
                    width: 240px;
                    height: auto;
                }
                &::after{
                    content: '';
                    width: 11px;
                    height: 11px;
                    background: #F3385A;
                    position: absolute;
                    right: 12px;
                    bottom: -3px;
                    -webkit-transform: rotate(45deg);
                    transform: rotate(45deg);
                    border-radius: 3px;
                }
            }
        }
    }

    .dropdown {
        position: absolute;
        background-color: white;
        border: 1px solid #ccc;
        width: 100%;
        max-height: 340px;
        overflow-y: auto;
        z-index: 1000;

        ul {
            list-style: none;
            padding: 0;
            margin: 0;
        }

        li {
            padding: 8px 16px;
            cursor: pointer;
        }

        li:hover {
            background-color: #f0f0f0;
        }
    }

    .relative-container {
        position: relative;

        .input-suffix {
            position: absolute; 
            bottom: 10px; 
            right: 12px;
            font-size: 15px;
        }
        .cena-input {
            padding-right: 25px;
        }
    }

</style>